// extracted by mini-css-extract-plugin
export default {"addExpenseButton":"AddExpenseButton_addExpenseButton__rw9vZ","addExpenseIcon":"AddExpenseButton_addExpenseIcon__xRZRQ","addExpenseLabel":"AddExpenseButton_addExpenseLabel__NE5mF"};